import {
  base_colorContentBorder,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_md,
  font_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  display: flex;
  flex-direction: column;

  .CardStatusLifecycleTile-freezeRow,
  .CardStatusLifecycleTile-row {
    display: flex;
    justify-content: space-between;
    gap: ${spacing(4)};
    padding: ${spacing(3)} 0;
    border-bottom: 1px solid ${base_colorContentBorder};
  }

  .CardStatusLifecycleTile-freezeRow {
    align-items: center;
  }

  .CardStatusLifecycleTile-row {
    align-items: flex-start;
  }

  .CardStatusLifecycleTile-rowText {
    min-width: 0;
  }

  .CardStatusLifecycleTile-freezeHeading {
    display: flex;
    align-items: center;
    gap: ${spacing(2)};
    flex-wrap: wrap;
  }

  .CardStatusLifecycleTile-rowTitle {
    font-family: ${font_family_weight_medium};
    ${font_md};
    color: ${text_colorTextPrimary};
  }

  .CardStatusLifecycleTile-rowSub {
    margin-top: ${spacing(1)};
    max-width: 44ch;
    font-family: ${font_family_weight_regular};
    ${font_sm};
    color: ${text_colorTextSecondary};
  }

  button {
    flex: 0 0 auto;
  }
`
